import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../components/ui/dialog";
import { motion } from "framer-motion";

const InstructionsModal = ({ isOpen, onClose }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="glass border-white/10 max-w-md" data-testid="instructions-modal">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-gold text-center">
            How To Play
          </DialogTitle>
        </DialogHeader>
        
        <div className="space-y-6 py-4">
          <p className="text-text-secondary font-body text-center">
            Guess the Bollywood movie title in 6 tries!
          </p>
          
          <div className="space-y-4">
            <p className="text-text-primary font-body text-sm">
              After each guess, the tiles will change color to show how close your guess was.
            </p>
            
            {/* Example: Correct */}
            <div className="space-y-2">
              <div className="flex gap-1 justify-center">
                <ExampleTile letter="S" state="correct" />
                <ExampleTile letter="H" state="empty" />
                <ExampleTile letter="O" state="empty" />
                <ExampleTile letter="L" state="empty" />
                <ExampleTile letter="A" state="empty" />
                <ExampleTile letter="Y" state="empty" />
              </div>
              <p className="text-xs text-text-secondary text-center font-body">
                <span className="text-game-correct font-semibold">S</span> is in the word and in the correct spot
              </p>
            </div>
            
            {/* Example: Present */}
            <div className="space-y-2">
              <div className="flex gap-1 justify-center">
                <ExampleTile letter="D" state="empty" />
                <ExampleTile letter="H" state="present" />
                <ExampleTile letter="O" state="empty" />
                <ExampleTile letter="O" state="empty" />
                <ExampleTile letter="M" state="empty" />
              </div>
              <p className="text-xs text-text-secondary text-center font-body">
                <span className="text-game-present font-semibold">H</span> is in the word but in the wrong spot
              </p>
            </div>
            
            {/* Example: Absent */}
            <div className="space-y-2">
              <div className="flex gap-1 justify-center">
                <ExampleTile letter="Q" state="absent" />
                <ExampleTile letter="U" state="empty" />
                <ExampleTile letter="E" state="empty" />
                <ExampleTile letter="E" state="empty" />
                <ExampleTile letter="N" state="empty" />
              </div>
              <p className="text-xs text-text-secondary text-center font-body">
                <span className="text-text-muted font-semibold">Q</span> is not in the word
              </p>
            </div>
          </div>
          
          <div className="border-t border-white/10 pt-4">
            <p className="text-text-muted text-xs text-center font-body">
              A new movie is available each day!<br />
              <span className="text-gold">Hint:</span> After 5 attempts, a hint button appears.
            </p>
          </div>
          
          <motion.button
            onClick={onClose}
            className="w-full py-3 bg-gold text-dark font-body font-semibold rounded-lg"
            whileTap={{ scale: 0.98 }}
            data-testid="instructions-close-button"
          >
            Let's Play!
          </motion.button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

const ExampleTile = ({ letter, state }) => {
  const stateClasses = {
    empty: "bg-dark-paper border-game-border-empty",
    correct: "bg-game-correct border-game-correct",
    present: "bg-game-present border-game-present",
    absent: "bg-game-absent border-game-absent",
  };
  
  return (
    <div
      className={`
        w-10 h-10
        flex items-center justify-center
        font-game font-bold text-lg
        rounded-md border-2
        ${stateClasses[state]}
      `}
    >
      {letter}
    </div>
  );
};

export default InstructionsModal;
